import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center px-5 pb-3 gap-2 h-9" }
const _hoisted_2 = { class: "capitalize inline-block" }
const _hoisted_3 = { class: "flex flex-1 flex-col gap-2 pr-5 pl-5" }

import { ref } from 'vue';
import { WorkflowTask } from '@/http/workflowTask';
import { NodeProps, Position } from '@vue-flow/core';
import { Handle } from '@vue-flow/core';
import WorkflowTaskIcon from './WorkflowTaskIcon.vue';
import Button from '../ui/button/Button.vue';
import { Settings } from 'lucide-vue-next';
import WorkflowTaskSettings from './WorkflowTaskSettings.vue';
import Input from '../ui/input/Input.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListReplyNode',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: [Boolean, Number, String, Function] },
    position: {},
    dimensions: {},
    label: {},
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    parent: {},
    parentNodeId: {},
    dragging: { type: Boolean },
    resizing: { type: Boolean },
    zIndex: {},
    targetPosition: {},
    sourcePosition: {},
    dragHandle: {},
    data: {},
    events: {}
  },
  setup(__props: any) {

const props = __props;
const workflowTask = ref<WorkflowTask>(props.data);
const taskTitle = ref(props.data.title);
const height = (3 * Object.keys(props.data.availableReplies).length) + 7;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex-none w-60 rounded-2xl bg-white shadow-lg shadow-gray-500 pt-4 pb-1 select-none",
      style: _normalizeStyle({
      'height': `${height}rem`
    })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WorkflowTaskIcon, {
          workflowTaskType: props.data.type,
          workflowTaskSubtype: props.data.interactiveSubtype
        }, null, 8, ["workflowTaskType", "workflowTaskSubtype"]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(props.data.interactiveSubtype?.toLocaleLowerCase()), 1),
        _createVNode(WorkflowTaskSettings, {
          workflowTask: workflowTask.value,
          "onUpdate:workflowTask": _cache[0] || (_cache[0] = ($event: any) => ((workflowTask).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(Button, {
              variant: "ghost",
              class: "p-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Settings), { size: 16 })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["workflowTask"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Input, {
          modelValue: taskTitle.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((taskTitle).value = $event)),
          placeholder: "Título",
          class: "text-center rounded-xl font-bold border-dotted"
        }, null, 8, ["modelValue"])
      ])
    ], 4),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_L`,
      type: "source",
      position: _unref(Position).Left
    }, null, 8, ["id", "position"])
  ], 64))
}
}

})